import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-vessel-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 14.6667H8.66602V8.00004C8.66602 7.6464 8.80649 7.30726
          9.05654 7.05721C9.30659 6.80716 9.64573 6.66671 9.99935
          6.66671H13.9993V4.00004H17.9993V6.66671H21.9993C22.353 6.66671
          22.6921 6.80716 22.9422 7.05721C23.1922 7.30726 23.3327 7.6464
          23.3327 8.00004V14.6667H25.3327L22.6414 22.3947C22.4536 22.9385
          22.1002 23.4104 21.6303 23.7434C21.1604 24.0763 20.5973 24.2537
          20.0207 24.2507H11.9793C11.4021 24.2545 10.8382 24.0774 10.3676
          23.7444C9.89696 23.4114 9.5433 22.9391 9.35535 22.3947L6.66602
          14.6667ZM11.3327 9.33337V14.6667H20.6660V9.33337H11.3327Z"
        fill="white"
      />
      <path
        d="M4 26.6667C5.10457 27.5556 6.6087 28 8 28C9.39131 28 10.8954
          27.5556 12 26.6667C13.1046 27.5556 14.6087 28 16 28C17.3913 28
          18.8954 27.5556 20 26.6667C21.1046 27.5556 22.6087 28 24 28C25.3913
          28 26.8954 27.5556 28 26.6667"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VesselIconComponent {}
